import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useEffect, useState } from "react";
import { api, LOGO_URL } from "../lib/api";

export default function Footer() {
  const [social, setSocial] = useState({ instagram_url: "", whatsapp_url: "", whatsapp_number: "" });
  useEffect(() => {
    api.get("/settings/social").then((r) => setSocial(r.data)).catch(() => {});
  }, []);
  return (
    <footer className="bg-[#1A1A1A] text-white mt-32" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="flex justify-center mb-12">
          <Link to="/" aria-label="Prize Joias">
            <img src={LOGO_URL} alt="Prize Joias" className="h-10 w-auto opacity-90 select-none" draggable={false} />
          </Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div>
            <p className="overline text-[#B8A88A] mb-4">Joias</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/joias/Colares" className="hover:text-white">Colares</Link></li>
              <li><Link to="/joias/Anéis" className="hover:text-white">Anéis</Link></li>
              <li><Link to="/joias/Brincos" className="hover:text-white">Brincos</Link></li>
              <li><Link to="/joias/Pingentes" className="hover:text-white">Pingentes</Link></li>
              <li><Link to="/joias/Pulseiras" className="hover:text-white">Pulseiras</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-[#B8A88A] mb-4">Para Você</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/try-on" className="hover:text-white">Try On Experience</Link></li>
              <li><Link to="/wishlist" className="hover:text-white">Minha Wishlist</Link></li>
              <li><Link to="/presentes" className="hover:text-white">Guia de Presentes</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-[#B8A88A] mb-4">Institucional</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              <li><Link to="/sobre" className="hover:text-white">Nossa história</Link></li>
              <li><Link to="/novidades" className="hover:text-white">Novidades</Link></li>
              <li><Link to="/politica-de-privacidade" className="hover:text-white" data-testid="footer-privacy-link">Política de Privacidade</Link></li>
            </ul>
          </div>
          <div>
            <p className="overline text-[#B8A88A] mb-4">Conecte-se</p>
            <ul className="space-y-2.5 text-sm text-white/70">
              {social.instagram_url ? (
                <li><a href={social.instagram_url} target="_blank" rel="noreferrer" className="hover:text-white inline-flex items-center gap-2" data-testid="footer-instagram"><Instagram size={14}/> Instagram</a></li>
              ) : (
                <li className="text-white/30 text-xs italic">Instagram (em breve)</li>
              )}
              {social.whatsapp_url ? (
                <li>
                  <a href={social.whatsapp_url} target="_blank" rel="noreferrer" className="hover:text-white inline-flex items-center gap-2" data-testid="footer-whatsapp">
                    <svg width="14" height="14" viewBox="0 0 32 32" aria-hidden="true">
                      <path fill="currentColor" d="M16 .4C7.4.4.5 7.3.5 15.9c0 2.8.7 5.5 2.1 7.9L.4 31.6l8-2.1a15.4 15.4 0 0 0 7.6 1.9h.1c8.6 0 15.5-7 15.5-15.5C31.6 7.3 24.6.4 16 .4Zm9.1 22a3.9 3.9 0 0 1-2.7 1.9c-.7.1-1.6.2-5.1-1.1-4.3-1.7-7.1-6.1-7.3-6.4-.2-.3-1.7-2.3-1.7-4.3 0-2.1 1.1-3.1 1.5-3.5.4-.4.9-.6 1.2-.6h.8c.3 0 .6 0 .9.7l1.4 3.4c.1.3.2.6 0 .9l-.4.6c-.2.3-.4.4-.6.7-.2.2-.4.5-.2.9.2.4.9 1.5 2 2.4 1.4 1.2 2.5 1.6 2.8 1.8.3.2.6.1.8-.1.2-.3.9-1.1 1.2-1.5.3-.4.5-.3.9-.2.4.2 2.4 1.1 2.8 1.3.4.2.7.3.8.5.2.4.2 1.4-.2 2.6Z"/>
                    </svg>
                    WhatsApp
                  </a>
                </li>
              ) : (
                <li className="text-white/30 text-xs italic">WhatsApp (em breve)</li>
              )}
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col md:flex-row justify-between items-center text-xs text-white/40">
          <p>© 2026 Prize Joias · Todos os direitos reservados</p>
          <p className="font-italic-display text-[#B8A88A]/60 mt-2 md:mt-0">Cada peça conta uma história.</p>
        </div>
        <div className="mt-4 text-center">
          <Link to="/admin" className="text-[#333333] text-[10px]" data-testid="admin-link">admin</Link>
        </div>
      </div>
    </footer>
  );
}
